import React, { FC, useEffect, useState } from 'react';
import { useAsync } from 'react-use';
import { useRouter } from 'next/router';
import { Button, Card, Col, Grid, Image, Row, Typography } from 'antd';
import { ButtonBorder } from 'src/components/Forms/Button';
import g from 'src/constants/urls';
import classes from './article.module.less';
interface CardArticleInterface {
  data?: any;
  type?: any;
}
const CardArticleHBAuthor: FC<CardArticleInterface> = props => {
  const {
    xs,
    sm
  } = Grid.useBreakpoint();
  const firstData = props.data;
  const [count, setCount] = useState(1);
  const [mergeData, setMergeData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [dataLength, setDataLength] = useState(false);
  const router = useRouter();
  const subCategorySlug = router.query.sub;
  const truncateString = (str: string) => {
    if (str?.length > 55) {
      return `${str.substring(0, 52)}...`;
    }
    return str;
  };
  const truncateString2 = (str: string) => {
    if (str?.length > 90) {
      return `${str.substring(0, 87)}...`;
    }
    return str;
  };
  useEffect(() => {
    setMergeData(firstData);
  }, [firstData]);
  const handleClick = () => {
    setCount(count + 1);
    setLoading(true);
  };
  useAsync(async () => {
    try {
      // eslint-disable-next-line max-len
      const uri = `${g.API_ARTICLE_SLUG}/articles/author/${subCategorySlug}?order=desc&orderby=publish_date&per_page=10&page=${count}`;
      const opts = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      const faqList = await fetch(uri, opts);
      const data: any = await faqList.json().then(res => ({
        ...res,
        status: faqList.status
      }));
      if (data?.status === 200) {
        const newData = data.data.records;
        setMergeData([...mergeData, ...newData]);
        setLoading(false);
        setDataLength(newData.length === 0 ? true : false);
      } else {
        setMergeData([...mergeData]);
        setLoading(false);
      }
    } catch (error) {}
  }, [count]);
  return <div className={classes.containerCard}>
			<Row>
				{mergeData?.length == 0 ? props?.data?.map((item: any) => {
        return <Col sm={24} md={24} lg={24} xl={24} xs={24} key={item.uid}>
									{!xs ? <a href={`${item.type == 'post-pregnancy' ? '/pasca-kehamilan/' : item.type == 'pre-pregnancy' ? '/pra-kehamilan/' : item.type == 'pregnancy' ? '/kehamilan/' : item.type == 'recipe' ? '/resep/' : '/artikel/'}` + item.slug}>
											<span>
												<Card size="small" hoverable={false} className={classes.cards} style={{
                cursor: 'pointer'
              }}>
													<Row>
														<Col sm={10} md={10} lg={10} xl={10} xs={10}>
															<Image alt={item.title} src={item?.media_images_new?.original} style={{
                      width: `${xs ? '220px' : sm ? '160px' : '225px'}`,
                      height: `${xs ? '120px' : sm ? '120px' : '152px'}`,
                      borderRadius: '12px',
                      objectFit: 'cover'
                    }} preview={false} loading='lazy' />
														</Col>
														<Col sm={14} md={14} lg={14} xl={14} xs={14} style={{
                    marginLeft: '-20px'
                  }}>
															<div style={{
                      marginTop: '0px'
                    }}>
																<div>
																	<p className={classes.title}>
																		{truncateString(item.title)}
																	</p>
																</div>

																<div className="d-flex align-items-center" style={{
                        marginLeft: xs ? '-5px' : sm ? '-5px' : '-15px'
                      }}>
																	<Typography className="fs-12 fs-md-14" style={{
                          color: '#9ca3aa'
                        }}>
																		{truncateString2(item?.short_desc) || ''}
																	</Typography>
																</div>
																<div style={{
                        marginLeft: xs ? '-5px' : sm ? '-5px' : '-15px'
                      }}>
																	<ButtonBorder style={{
                          backgroundColor: 'white',
                          color: '#F48A8A',
                          cursor: 'pointer'
                        }} text={item?.type === 'post-pregnancy' ? 'Pasca Kehamilan' : item?.type === 'pre-pregnancy' ? 'Pra Kehamilan' : item?.type === 'recipe' ? 'Resep' : 'Kehamilan'} />
																</div>
															</div>
														</Col>
													</Row>
												</Card>
											</span>
										</a> : <a href={`${item.type == 'post-pregnancy' ? '/pasca-kehamilan/' : item.type == 'pre-pregnancy' ? '/pra-kehamilan/' : item.type == 'pregnancy' ? '/kehamilan/' : item.type == 'recipe' ? '/resep/' : '/artikel/'}` + item.slug}>
											<span>
												<Card size="small" hoverable={false} className={classes.cards} style={{
                cursor: 'pointer'
              }} cover={<Image alt={item.title} src={item?.media_images_new?.original} className={classes.imageContainer} style={{
                width: `${xs ? '225px' : '367px'}`,
                height: `${xs ? '152px' : '203px'}`,
                borderRadius: '12px',
                objectFit: 'cover'
              }} preview={false} loading='lazy' />}>
													<Typography className={classes.title}>{truncateString(item.title)}</Typography>
													<Row>
														<Col className="d-flex align-items-center" style={{
                    marginLeft: xs ? '-8px' : '-15px'
                  }}>
															<Typography className={classes.title}>
																{truncateString(item.title)}
															</Typography>
														</Col>
													</Row>
													<Row>
														<Col className="d-flex align-items-center" style={{
                    marginLeft: xs ? '-13px' : '-15px'
                  }}>
															<Typography className="fs-12 fs-md-14" style={{
                      color: '#9ca3aa'
                    }}>
																{truncateString2(item?.short_desc) || ''}
															</Typography>
														</Col>
													</Row>
													<Row>
														<div style={{
                    marginLeft: '-15px'
                  }}>
															<ButtonBorder style={{
                      backgroundColor: 'white',
                      color: '#F48A8A',
                      cursor: 'pointer'
                    }} text={item?.type === 'post-pregnancy' ? 'Pasca Kehamilan' : item?.type === 'pre-pregnancy' ? 'Pra Kehamilan' : item?.type === 'recipe' ? 'Resep' : 'Kehamilan'} />
														</div>
													</Row>
												</Card>
											</span>
										</a>}
								</Col>;
      }) : mergeData?.map((item: any) => {
        return <Col sm={24} md={24} lg={24} xl={24} xs={24} key={item.uid}>
									{!xs ? <a href={`${item.type == 'post-pregnancy' ? '/pasca-kehamilan/' : item.type == 'pre-pregnancy' ? '/pra-kehamilan/' : item.type == 'pregnancy' ? '/kehamilan/' : item.type == 'recipe' ? '/resep/' : '/artikel/'}` + item.slug}>
											<span>
												<Card size="small" hoverable={false} className={classes.cards} style={{
                cursor: 'pointer'
              }}>
													<Row>
														<Col sm={10} md={10} lg={10} xl={10} xs={10}>
															<Image alt={item.title} src={item?.media_images_new?.original} style={{
                      width: `${xs ? '220px' : sm ? '160px' : '225px'}`,
                      height: `${xs ? '120px' : sm ? '120px' : '152px'}`,
                      borderRadius: '12px',
                      objectFit: 'cover'
                    }} preview={false} loading='lazy' />
														</Col>
														<Col sm={14} md={14} lg={14} xl={14} xs={14}>
															<div style={{
                      marginTop: '0px'
                    }}>
																<Typography className={classes.title}>
																	{truncateString(item.title)}
																</Typography>
																<div className="d-flex align-items-center" style={{
                        marginLeft: xs ? '-5px' : sm ? '-5px' : '-15px'
                      }}>
																	<Typography className="fs-12 fs-md-14" style={{
                          color: '#9ca3aa'
                        }}>
																		{truncateString2(item?.short_desc) || ''}
																	</Typography>
																</div>
																<div style={{
                        marginLeft: xs ? '-5px' : sm ? '-5px' : '-15px'
                      }}>
																	<ButtonBorder style={{
                          backgroundColor: 'white',
                          color: '#F48A8A',
                          cursor: 'pointer'
                        }} text={item?.type === 'post-pregnancy' ? 'Pasca Kehamilan' : item?.type === 'pre-pregnancy' ? 'Pra Kehamilan' : item?.type === 'recipe' ? 'Resep' : 'Kehamilan'} />
																</div>
															</div>
														</Col>
													</Row>
												</Card>
											</span>
										</a> : <a href={`${item.type == 'post-pregnancy' ? '/pasca-kehamilan/' : item.type == 'pre-pregnancy' ? '/pra-kehamilan/' : item.type == 'pregnancy' ? '/kehamilan/' : item.type == 'recipe' ? '/resep/' : '/artikel/'}` + item.slug}>
											<span>
												<Card size="small" hoverable={false} className={classes.cards} style={{
                cursor: 'pointer'
              }} cover={<Image alt={item.title} src={item?.media_images_new?.original} className={classes.imageContainer} style={{
                width: `${xs ? '225px' : '367px'}`,
                height: `${xs ? '152px' : '203px'}`,
                borderRadius: '12px',
                objectFit: 'cover'
              }} preview={false} loading='lazy' />}>
													<Row>
														<Col className="d-flex align-items-center" style={{
                    marginLeft: xs ? '-8px' : '-15px'
                  }}>
															<Typography className={classes.title}>
																{truncateString(item.title)}
															</Typography>
														</Col>
													</Row>
													<Row>
														<Col className="d-flex align-items-center" style={{
                    marginLeft: xs ? '-13px' : '-15px'
                  }}>
															<Typography className="fs-12 fs-md-14" style={{
                      color: '#9ca3aa'
                    }}>
																{truncateString2(item?.short_desc) || ''}
															</Typography>
														</Col>
													</Row>
													<Row>
														<div style={{
                    marginLeft: '-15px'
                  }}>
															<ButtonBorder style={{
                      backgroundColor: 'white',
                      color: '#F48A8A',
                      cursor: 'pointer'
                    }} text={item?.type === 'post-pregnancy' ? 'Pasca Kehamilan' : item?.type === 'pre-pregnancy' ? 'Pra Kehamilan' : item?.type === 'recipe' ? 'Resep' : 'Kehamilan'} />
														</div>
													</Row>
												</Card>
											</span>
										</a>}
								</Col>;
      })}
			</Row>
			{dataLength === true || mergeData?.length < 9 ? '' : <div className={classes.btnFooter}>
						<Button className={classes.btn} onClick={handleClick} loading={loading} size="large">
							Artikel Lainnya
						</Button>
					</div>}
		</div>;
};
export default CardArticleHBAuthor;